import { combineReducers } from 'redux';
import documents from './case-documents.reducer';

const reducers = () => combineReducers({ documents });

export default reducers;
